import { FunctionComponent } from 'react';
import { Moment } from 'moment-timezone';
import { Option } from '@spike/model';
import styles from './PeriodSelector.module.scss';
import clsx from 'clsx';
import PeriodSelectorSection from './PeriodSelectorSection';

interface PeriodSelectorProps {
    from: Moment;
    to: Moment;
    duration?: Option<string>;
    readOnly?: boolean;
    labelTimeStart?: string;
    labelTimeEnd?: string;
    onChangePeriod: (from: Moment, to: Moment, nights: number) => void;
}

export const PeriodSelector: FunctionComponent<PeriodSelectorProps> = props => {
    return (
        <div className={clsx(styles.container)}>
            <div className={styles.dateSelectorContainer}>
                <PeriodSelectorSection
                    from={props.from}
                    to={props.to}
                    labelTimeStart={props.labelTimeStart}
                    labelTimeEnd={props.labelTimeEnd}
                    readOnly={props.readOnly}
                    className={clsx(styles.noRecurrent)}
                    onSelectPeriod={props.onChangePeriod}
                />
            </div>
        </div>
    );
};

export default PeriodSelector;
